import * as React from "react";
export class Swiper extends React.Component {
    constructor(props) {
        super(props);
        this.handleTouchEnd = (e) => {
            // if the user released on a different target, cancel!
            if (this.startEl !== e.target)
                return;
            const swipeThreshold = parseInt((this.startEl &&
                this.startEl.getAttribute &&
                this.startEl.getAttribute("data-swipe-threshold")) ||
                "20", 10); // default 10px
            const swipeTimeout = parseInt((this.startEl &&
                this.startEl.getAttribute &&
                this.startEl.getAttribute("data-swipe-timeout")) ||
                "500", 10); // default 1000ms
            const timeDiff = Date.now() - this.timeDown;
            let eventType = "";
            if (Math.abs(this.xDiff) > Math.abs(this.yDiff)) {
                // most significant
                if (Math.abs(this.xDiff) > swipeThreshold && timeDiff < swipeTimeout) {
                    if (this.xDiff > 0) {
                        eventType = "swiped-left";
                    }
                    else {
                        eventType = "swiped-right";
                    }
                }
            }
            else {
                if (Math.abs(this.yDiff) > swipeThreshold && timeDiff < swipeTimeout) {
                    if (this.yDiff > 0) {
                        eventType = "swiped-up";
                    }
                    else {
                        eventType = "swiped-down";
                    }
                }
            }
            if (eventType !== "") {
                this.props.onSwipe && this.props.onSwipe(eventType);
            }
            // reset values
            this.xDown = 0;
            this.yDown = 0;
            this.timeDown = 0;
        };
        this.handleTouchStart = (e) => {
            this.startEl = e.target;
            this.timeDown = Date.now();
            this.xDown = e.touches[0].clientX;
            this.yDown = e.touches[0].clientY;
            this.xDiff = 0;
            this.yDiff = 0;
        };
        this.handleTouchMove = (e) => {
            if (!this.xDown || !this.yDown)
                return;
            const xUp = e.touches[0].clientX;
            const yUp = e.touches[0].clientY;
            this.xDiff = this.xDown - xUp;
            this.yDiff = this.yDown - yUp;
        };
        this.destroy = () => {
            if (this.ref) {
                this.ref.removeEventListener("touchstart", this.handleTouchStart);
                this.ref.removeEventListener("touchmove", this.handleTouchMove);
                this.ref.removeEventListener("touchend", this.handleTouchEnd);
            }
        };
        this.xDown = 0;
        this.yDown = 0;
        this.xDiff = 0;
        this.yDiff = 0;
        this.timeDown = 0;
        this.startEl = null;
        this.ref = React.createRef();
    }
    componentDidMount() {
        if (this.ref) {
            this.ref.current.addEventListener("touchstart", this.handleTouchStart, {
                passive: true,
            });
            this.ref.current.addEventListener("touchmove", this.handleTouchMove, {
                passive: true,
            });
            this.ref.current.addEventListener("touchend", this.handleTouchEnd, {
                passive: true,
            });
        }
    }
    render() {
        return React.createElement("div", { ref: this.ref }, this.props.children);
    }
}

